
// Editor-specific iframe probing removed to avoid noisy logs in editor
